import React, { useState, useEffect } from 'react'
import { Row, Col, Form, Button, Table } from 'react-bootstrap'
import Card from '../../../components/Card'
import { toast } from 'react-toastify';
import { API_COMPANY_CREATE, API_PARENT_COMPANY_LICENCE, API_MANAGE_LOCATIONS_LIST, API_MANAGE_GROUP_LISTING, API_CALL_STRATEGIES_MASTER_LIST, API_COMPANY_PROFILE } from '../../../service/url';
import { postApiCall, getApiCall, fetchAndSetFlashMessage } from '../../../service/httpCall';
import { useNavigate } from 'react-router-dom';
import { ROUTES, USER_ROLES, MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT } from '../../../utilities/constant';
import RenderUserCompanyFields from "../../../components/partials/dashboard/users/company";
import { validatePhone } from "../../../utilities/helpers";
import AsyncStorage from '@react-native-async-storage/async-storage';
import Select from 'react-select';


const CompanyCreate = () => {

  const navigate = useNavigate();

  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyPincode, setCompanyPincode] = useState("");
  const [companyLicence, setCompanyLicence] = useState("");
  const [parentLicence, setParentLicence] = useState(null);
  const [callCenterAdminTeamlead, setCallCenterAdminTeamlead] = useState(0);
  const [agent, setAgent] = useState(0);
  const [liveAgent, setLiveAgent] = useState(0);
  const [channel, setChannel] = useState(0);
  const [errors, setErrors] = useState({});
  const [availableLicence, setAvailableLicence] = useState({});
  const [asReseller, setAsReseller] = useState(0);
  const [asCompany, setAsCompany] = useState(0);
  const [loginUserRole, setLoginUserRole] = useState(null);
  const [locations, setLocations] = useState([]);
  const [callStrategies, setCallStrategies] = useState([]);
  const [selectedCallStrategy, setSelectedCallStrategy] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [isResellerCompany, setIsResellerCompany] = useState(null);
  const [isOwnCompany, setIsOwnCompany] = useState(null);
  const [resellerCreationBlocked, setResellerCreationBlocked] = useState(false);
  const [notes, setNotes] = useState([]);

  const handleResellerChange = (checked) => {
    if (resellerCreationBlocked) {
      toast.error("Reseller chain limit reached. You can only create an End User.");
      return;
    }
    setIsResellerCompany(checked);
    setIsOwnCompany(false);
  };

  const handleOwnCompanyChange = (checked) => {
    setIsOwnCompany(checked);
    setIsResellerCompany(false);
  };



  // useEffect( () => {

  //    if(toastProps){
  //       setShowToast(true);
  //    }

  // }, [toastProps]);

  useEffect(() => {
    const fetchMetaData = async () => {
      const user = JSON.parse(await AsyncStorage.getItem("user"));

      try {
        const [locationsData, groupsData, callStrategiesData] = await Promise.all([
          getApiCall(API_MANAGE_LOCATIONS_LIST, {}),
          getApiCall(API_MANAGE_GROUP_LISTING, {}),
          getApiCall(API_CALL_STRATEGIES_MASTER_LIST, {})
        ]);

        setCallStrategies(callStrategiesData?.map(strategy => ({
          value: strategy.id,
          label: strategy.name
        })) || []);

        if (user.role === USER_ROLES.SUPERADMIN) {
          // Normalize API data -> always { value, label }
          const normalizedLocations =
            (locationsData || []).map(loc => ({
              value: loc.location_id,
              label: loc.location_name,
            })) || [];

          const normalizedGroups =
            (groupsData || []).map(g => ({
              value: g.group_id,
              label: g.group_name,
            })) || [];

          setLocations(normalizedLocations);
          setGroups(normalizedGroups);
        } else {
          // Normalize user-based data -> always { value, label }
          const userGroups =
            groupsData.map(ug => ({
              value: ug.group_id,
              label: ug.group_name,
            })) || [];
          const userLocations =
            locationsData?.map(ul => ({
              value: ul.location_id,
              label: ul.location_name,
            })) || [];

          setGroups(userGroups);
          setLocations(userLocations);
        }
      } catch (error) {
        console.error("Error fetching groups/locations:", error);
      }
    };
    fetchMetaData();

    fetchAndSetFlashMessage(
      msg => msg.module_name === MODULE_ACL.COMPANY && msg.action === FLASH_MESSAGE_ACTION_OBJECT.ADD && msg.type === 'Note',
      setNotes
    );
  }, []);

  useEffect(() => {
    getUser();
  }, [])

  useEffect(() => {
    getApiCall(API_PARENT_COMPANY_LICENCE).then((resp) => {
      setParentLicence(resp?.parentLicence);
    }).catch((error) => {
      toast.error(JSON.stringify(error));
    });
  }, []);

  const validateInput = (value, key) => {
    const num = Number(value);
    let newErrors = { ...errors };

    if (Number.isNaN(num)) return 0;

    if (num < 0) {
      newErrors[key] = "Value cannot be negative";
      setErrors(newErrors);
      return 0;
    }

    const licenceKeyMap = {
      role_ccadmin: "role_ccadmin",
      agent: "role_ccagent",
      live_agent: "live_agent",
      channel: "channel",
      reseller: "reseller",
      company: "company",
    };

    const licenceKey = licenceKeyMap[key];
    const availableValue = parentLicence?.available_licence?.[licenceKey];

    if (availableValue === 0 && num > 0) {
      newErrors[key] = "Value cannot be more than 0";
      setErrors(newErrors);
      return num;
    }

    newErrors[key] = "";

    const nextAgent = key === "agent" ? num : agent;
    const nextLiveAgent = key === "live_agent" ? num : liveAgent;

    if (nextAgent < nextLiveAgent) {
      newErrors.agent = "Total Agent cannot be less than Live Agent";
      newErrors.live_agent = "Live Agent cannot be more than Total Agent";
    } else {
      newErrors.agent = "";
      newErrors.live_agent = "";
    }

    if (
      availableValue !== null &&
      availableValue !== undefined &&
      availableValue > 0
    ) {
      if (
        key === "company" &&
        num > availableValue - 1
      ) {
        newErrors.company = `Value cannot be more than ${availableValue - 1}`;
      }

      if (
        key !== "company" &&
        num > availableValue
      ) {
        newErrors[key] = `Value cannot be more than ${availableValue}`;
      }
    }

    if (key === "live_agent" && num > nextAgent) {
      newErrors.live_agent = `Live Agent cannot be more than Total Agent (${nextAgent})`;
    }

    setErrors(newErrors);
    return num;
  };

  async function getUser() {
    try {
      const user = JSON.parse(await AsyncStorage.getItem('user'));
      if (user) {
        setLoginUserRole(user.role);
        const myCompany = user.assignedCompany;
        const parentUser = user.createdByUser;
        let parentCompany = null;
        if (parentUser) {
          if (parentUser.assigned_company) {
            const urlToFetch = API_COMPANY_PROFILE.replace(":id", parentUser.assigned_company);
            parentCompany = await getApiCall(urlToFetch);
          }
        }

        let resellerDepth = 0;

        if (myCompany?.is_reseller_company) resellerDepth++;
        if (parentCompany?.is_reseller_company) resellerDepth++;

        if (resellerDepth >= 2) {
          setResellerCreationBlocked(true);
          setIsOwnCompany(true);
          setIsResellerCompany(false);
        }
      }
    } catch (err) {
      console.log(err)
    }
  }


  function validateCompanyFields() {
    let valid = true;

    if (!companyName.trim()) {
      valid = false;
      toast.error("Company name required");
    } else if (!companyPhone.trim()) {
      valid = false;
      toast.error("Company phone required");
    } else if (!validateCompanyPhone(companyPhone)) {
      valid = false;
      //  setToastProps({
      //      message: "Company phone invalid format",
      //      type: "danger",
      toast.error("Company phone invalid format");
    } else if (!companyPincode.trim()) {
      valid = false;
      toast.error("Company pincode required");
    } else if (!/^\d{6}$/.test(companyPincode)) {
      valid = false;
      toast.error("Company pincode must be exactly 6 digits");
    } else if (!companyAddress.trim()) {
      valid = false;
      toast.error("Company address required");
    }
    if (!isResellerCompany && !isOwnCompany) {
      toast.error("Please select either Reseller Company or End User");
      return false;
    }
    return valid;
  }

  function validateCompanyPhone(phone) {
    if (!phone) return false;
    return /^[0-9]{10}$/.test(phone.trim());
  }

  async function submitForm() {
    setButtonDisable(true);

    if (!validateCompanyFields()) {
      setButtonDisable(false);
      return;
    }

    if (resellerCreationBlocked && isResellerCompany) {
      toast.error("You are not allowed to create a Reseller Company. Please create an End User.");
      setButtonDisable(false);
      return;
    }

    if (liveAgent > agent) {
      toast.error("Live Agent cannot exceed Total Agents");
      setButtonDisable(false);
      return;
    }

    // Add this new validation check for available licences
    if (Object.values(errors).some(error => error !== "")) {
      toast.error("Please fix all validation errors before submitting");
      setButtonDisable(false);
      return;
    }

    const params = {
      name: companyName,
      phone: companyPhone,
      address: companyAddress,
      pincode: companyPincode,
      is_reseller_company: isResellerCompany,
      is_own_company: isOwnCompany,
      licence: {
        role_ccadmin: callCenterAdminTeamlead,
        role_ccagent: agent,
        live_agent: liveAgent,
        channel: channel,
        reseller: 0, // use asReseller when reseller box uncommented
        company: isOwnCompany ? 0 : asCompany,
      }
    }

    if (selectedGroup && selectedGroup.length > 0) {
      params.groups = Array.isArray(selectedGroup)
        ? selectedGroup.map(Number)
        : [Number(selectedGroup)];
    }

    if (selectedLocation && selectedLocation.length > 0) {
      params.locations = Array.isArray(selectedLocation)
        ? selectedLocation.map(Number)
        : [Number(selectedLocation)];
    }
    if (selectedCallStrategy && selectedCallStrategy.length > 0) {
      params.call_strategies = Array.isArray(selectedCallStrategy)
        ? selectedCallStrategy.map(Number)
        : [Number(selectedCallStrategy)];
    }

    postApiCall(API_COMPANY_CREATE, params)
      .then(onCreateCreateSuccess)
      .catch(onError);
  }


  function onCreateCreateSuccess(resp) {
    toast.success("Company created successfully");
    setTimeout(() => {
      navigate(`/${ROUTES.COMPANIES.LIST}`);
    }, 1500);
  }

  function onError(err) {
    setButtonDisable(false);
    console.log(err);
    toast.error(JSON.stringify(err));
  }

  return (
    <>
      <div>
        <Row>
          <Col xl="12" lg="12">
            <Card>
              <Card.Header className="d-flex justify-content-between">
                <div className="header-title">
                  <h4 className="card-title">New Company Information</h4>
                </div>
              </Card.Header>
              <Card.Body>
                <div className="new-user-info">
                  <form>
                    {RenderUserCompanyFields({
                      company_name: companyName,
                      set_company_name: setCompanyName,
                      company_phone: companyPhone,
                      set_company_phone: setCompanyPhone,
                      company_address: companyAddress,
                      set_company_address: setCompanyAddress,
                      company_pincode: companyPincode,
                      set_company_pincode: setCompanyPincode,
                      isResellerCompany: isResellerCompany,
                      isOwnCompany: isOwnCompany,
                      onResellerChange: handleResellerChange,
                      onOwnCompanyChange: handleOwnCompanyChange,
                      resellerCreationBlocked: resellerCreationBlocked,
                      // company_licence: companyLicence,
                      // set_company_licence: setCompanyLicence,
                    })}
                    <div className="row">
                      {/* Call Strategy */}
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label>Call Strategy:</Form.Label>
                        <Select
                                    className="theme-react-select"
                                    classNamePrefix="theme-react-select"
                          options={callStrategies}
                          value={callStrategies.filter(l =>
                            selectedCallStrategy.includes(l.value)
                          )}
                          onChange={selected =>
                            setSelectedCallStrategy(selected.map(s => s.value))
                          }
                          isMulti
                          placeholder="Select Call Strategy"
                        />
                      </Form.Group>

                      {/* Location */}
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label>Location:</Form.Label>
                        <Select
                                    className="theme-react-select"
                                    classNamePrefix="theme-react-select"
                          options={locations}
                          value={locations.filter(l =>
                            selectedLocation.includes(l.value)
                          )}
                          onChange={selected =>
                            setSelectedLocation(selected.map(s => s.value))
                          }
                          isMulti
                          placeholder="Select Location"
                        />
                      </Form.Group>
                    </div>


                    <div className="row">
                      <Form.Group className="col-md-6 form-group">
                        <Form.Label htmlFor="company_name"> Group:</Form.Label>
                        <Select
                                    className="theme-react-select"
                                    classNamePrefix="theme-react-select"
                          options={groups}
                          value={groups.filter(g => selectedGroup.includes(g.value))}
                          onChange={selected => setSelectedGroup(selected.map(s => s.value))}
                          isMulti
                          placeholder="Select Group"
                        />
                      </Form.Group>
                      <Form.Group className="col-md-6 d-flex flex-column gap-2">
                        <Form.Label>
                          Select Company Type <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <div className="d-flex gap-4">
                          {!resellerCreationBlocked && (
                            <Form.Check
                              type="checkbox"
                              id="reseller_company"
                              label="Reseller Company"
                              checked={isResellerCompany}
                              onChange={(e) => {
                                handleResellerChange(e.target.checked);
                              }}
                            />
                          )}

                          <Form.Check
                            type="checkbox"
                            id="own_company"
                            label="End User"
                            checked={isOwnCompany}
                            onChange={(e) => {
                              handleOwnCompanyChange(e.target.checked);
                            }}
                          />
                        </div>
                      </Form.Group>
                    </div>

                    <hr />
                    <div className="scroll-container" style={{ marginBottom: "30px" }}>
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
                        <h5 style={{ margin: 0 }}>Licence</h5>
                        {!isOwnCompany && (
                          <div
                            style={{
                              background: "#FFF8C6",
                              color: "#8B5A2B",
                              padding: "8px 12px",
                              borderRadius: "6px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "14px",
                              fontWeight: 500,
                            }}
                          >
                            <span>
                              {/* <strong>Note:</strong> One <strong>Company Licence </strong>is automatically used for the newly created company. */}
                              <strong>Note: </strong>{notes.find(n => Number(n.priority) === 1)?.message ?? ""}
                            </span>
                          </div>
                        )}

                      </div>

                      <Table striped bordered hover responsive
                        style={{
                          minWidth: "1000px", textAlign: "center", borderCollapse: "separate",
                          borderSpacing: "0",
                          borderRadius: "12px",
                          border: "1px solid #d5d7da",
                          overflow: "hidden",
                          boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)"
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={{
                              width: "15%",
                              // backgroundColor: "#f4f4f5",
                              // color: "#1e293b",
                              fontWeight: "700",
                              textTransform: "uppercase",
                              fontSize: "12px",
                              padding: "15px",
                              borderBottom: "2px solid  hsl(218deg 79.84% 36.85%)"
                            }}>Call Centers</th>
                            <th style={{
                              width: "15%",
                              // backgroundColor: "#f4f4f5",
                              // color: "#1e293b",
                              fontWeight: "700",
                              textTransform: "uppercase",
                              fontSize: "12px",
                              padding: "15px",
                              borderBottom: "2px solid  hsl(218deg 79.84% 36.85%)"
                            }}>Total Agent</th>
                            <th style={{
                              width: "15%",
                              // backgroundColor: "#f4f4f5",
                              // color: "#1e293b",
                              fontWeight: "700",
                              textTransform: "uppercase",
                              fontSize: "12px",
                              padding: "15px",
                              borderBottom: "2px solid  hsl(218deg 79.84% 36.85%)"
                            }}>Live Agent</th>
                            <th style={{
                              width: "15%",
                              // backgroundColor: "#f4f4f5",
                              // color: "#1e293b",
                              fontWeight: "700",
                              textTransform: "uppercase",
                              fontSize: "12px",
                              padding: "15px",
                              borderBottom: "2px solid  hsl(218deg 79.84% 36.85%)"
                            }}>Channels</th>
                            {/* {loginUserRole!==USER_ROLES.COMPANY_ADMIN &&
                                    <th style={{ width: "15%" }}>Reseller</th>} */}
                            {!isOwnCompany &&
                              <th style={{
                                width: "15%",
                                // backgroundColor: "#f4f4f5",
                                // color: "#1e293b",
                                fontWeight: "700",
                                textTransform: "uppercase",
                                fontSize: "12px",
                                padding: "15px",
                                borderBottom: "2px solid  hsl(218deg 79.84% 36.85%)"
                              }}>Company</th>}
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td style={{
                              // backgroundColor: "#f4f7ff",
                            }}>
                              <Form.Group className="form-group">
                                <Form.Control
                                  type="number"
                                  placeholder="Teamlead"
                                  min={0}
                                  max={availableLicence?.role_ccadmin}
                                  // value={callCenterAdminTeamlead}
                                  value={String(parseInt(String(callCenterAdminTeamlead), 10))}
                                  onChange={(e) => setCallCenterAdminTeamlead(validateInput(e.target.value, "role_ccadmin"))}
                                  required
                                 style={{ transition: "all 0.3s ease",
                                       border: "2px solid  hsl(218deg 79.84% 36.85%)"
                                     }}
                                    onFocus={(e) => {
                                      e.target.style.boxShadow = "0 0 0 4px rgba(26, 35, 126, 0.25)";
                                      e.target.style.borderColor = " hsl(218deg 79.84% 36.85%)";
                                    }}
                                    onBlur={(e) => {
                                      e.target.style.boxShadow = "none";
                                      e.target.style.borderColor = " hsl(218deg 79.84% 36.85%)";
                                    }}
                                />
                                {errors.role_ccadmin && <small className="text-danger">{errors.role_ccadmin}</small>}
                              </Form.Group>
                            </td>

                            <td style={{
                              // backgroundColor: "#f4f7ff"
                            }}>
                              <Form.Group className="form-group">
                                <Form.Control
                                  type="number"
                                  placeholder="Agent"
                                  min={0}
                                  max={availableLicence?.agent}
                                  // value={agent}
                                  value={String(parseInt(String(agent), 10))}
                                  onChange={(e) => setAgent(validateInput(e.target.value, "agent"))}
                                 style={{ transition: "all 0.3s ease",
                                       border: "2px solid  hsl(218deg 79.84% 36.85%)"
                                     }}
                                    onFocus={(e) => {
                                      e.target.style.boxShadow = "0 0 0 4px rgba(26, 35, 126, 0.25)";
                                      e.target.style.borderColor = " hsl(218deg 79.84% 36.85%)";
                                    }}
                                    onBlur={(e) => {
                                      e.target.style.boxShadow = "none";
                                      e.target.style.borderColor = " hsl(218deg 79.84% 36.85%)";
                                    }}
                                  required
                                />
                                {errors.agent && <small className="text-danger">{errors.agent}</small>}
                              </Form.Group>
                            </td>

                            <td style={{
                              // backgroundColor: "#f4f7ff"
                            }}>
                              <Form.Group className="form-group">
                                <Form.Control
                                  type="number"
                                  placeholder="Live Agent"
                                  min={0}
                                  // max={10}   
                                  // value={liveAgent}
                                  value={String(parseInt(String(liveAgent), 10))}
                                  onChange={(e) => setLiveAgent(validateInput(e.target.value, "live_agent"))}
                                 style={{ transition: "all 0.3s ease",
                                       border: "2px solid  hsl(218deg 79.84% 36.85%)"
                                     }}
                                    onFocus={(e) => {
                                      e.target.style.boxShadow = "0 0 0 4px rgba(26, 35, 126, 0.25)";
                                      e.target.style.borderColor = " hsl(218deg 79.84% 36.85%)";
                                    }}
                                    onBlur={(e) => {
                                      e.target.style.boxShadow = "none";
                                      e.target.style.borderColor = " hsl(218deg 79.84% 36.85%)";
                                    }}
                                  required
                                />
                                {errors.live_agent && <small className="text-danger">{errors.live_agent}</small>}
                              </Form.Group>
                            </td>


                            <td style={{
                              // backgroundColor: "#f4f7ff"
                            }}>
                              <Form.Group className="form-group">
                                <Form.Control
                                  type="number"
                                  placeholder="Channel"
                                  min={0}
                                  max={availableLicence?.channel}
                                  // value={channel}
                                  value={String(parseInt(String(channel), 10))}
                                  onChange={(e) => setChannel(validateInput(e.target.value, "channel"))}
                                  style={{ transition: "all 0.3s ease",
                                       border: "2px solid  hsl(218deg 79.84% 36.85%)"
                                     }}
                                    onFocus={(e) => {
                                      e.target.style.boxShadow = "0 0 0 4px rgba(26, 35, 126, 0.25)";
                                      e.target.style.borderColor = " hsl(218deg 79.84% 36.85%)";
                                    }}
                                    onBlur={(e) => {
                                      e.target.style.boxShadow = "none";
                                      e.target.style.borderColor = " hsl(218deg 79.84% 36.85%)";
                                    }}
                                  required
                                />
                                {errors.channel && <small className="text-danger">{errors.channel}</small>}
                              </Form.Group>
                            </td>
                            {/* // */}
                            {/* {loginUserRole!==USER_ROLES.COMPANY_ADMIN &&
                              <td>
                                  <Form.Group className="form-group">
                                    <Form.Control
                                      type="number"
                                      placeholder="As Reseller"
                                      min={0}
                                      max={availableLicence?.reseller}
                                      // value={asReseller}
                                      value={String(parseInt(String(asReseller), 10))}
                                      onChange={(e) => setAsReseller(validateInput(e.target.value, "reseller"))}
                                      required
                                    />
                                    {errors.reseller && <small className="text-danger">{errors.reseller}</small>}
                                  </Form.Group>
                                </td>} */}

                            {!isOwnCompany &&
                              <td style={{
                                // backgroundColor: "#f4f7ff"
                              }}>
                                <Form.Group className="form-group">
                                  <Form.Control
                                    type="number"
                                    placeholder="Company"
                                    min={0}
                                    max={availableLicence?.company}
                                    // value={asCompany}
                                    value={String(parseInt(String(asCompany), 10))}
                                    onChange={(e) => setAsCompany(validateInput(e.target.value, "company"))}
                                    style={{ transition: "all 0.3s ease",
                                       border: "2px solid  hsl(218deg 79.84% 36.85%)"
                                     }}
                                    onFocus={(e) => {
                                      e.target.style.boxShadow = "0 0 0 4px rgba(26, 35, 126, 0.25)";
                                      e.target.style.borderColor = " hsl(218deg 79.84% 36.85%)";
                                    }}
                                    onBlur={(e) => {
                                      e.target.style.boxShadow = "none";
                                      e.target.style.borderColor = " hsl(218deg 79.84% 36.85%)";
                                    }}
                                    required
                                  />
                                  {errors.company && <small className="text-danger">{errors.company}</small>}
                                </Form.Group>
                              </td>}

                          </tr>
                        </tbody>
                      </Table>
                    </div>
                    {loginUserRole !== USER_ROLES.SUPERADMIN &&
                      <div
                        style={{
                          background: "#FFF8C6",
                          color: "#8B5A2B",
                          padding: "8px 12px",
                          borderRadius: "6px",
                          display: "flex",
                          alignItems: "center",
                          fontSize: "14px",
                          fontWeight: 500,
                        }}  
                      >
                        {/* <span><strong>Note:</strong> This licence detail is informational purpose and cannot be edited.</span> */}
                        <strong>Note: </strong>{notes.find(n => Number(n.priority) === 2)?.message ?? ""}
                      </div>}

                    {loginUserRole !== USER_ROLES.SUPERADMIN &&
                      <div className="scroll-container" style={{ marginBottom: "30px", marginTop: "30px" }}>
                        <h5 style={{ marginBottom: "10px" }}>Available Licence {loginUserRole === USER_ROLES.SUPERADMIN ? "" : "(Allocated Company)"}</h5>
                        <Table striped bordered hover responsive style={{ minWidth: "1000px", textAlign: "center" }}>
                          <thead>
                            <tr>
                              <th>Call Centers</th>
                              <th>Agent</th>
                              <th>Live Agent</th>
                              <th>Channels</th>
                              {/* {loginUserRole!==USER_ROLES.COMPANY_ADMIN &&
                                      <th>Reseller</th>} */}
                              {!isOwnCompany &&
                                <th>Company</th>}
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{parentLicence?.available_licence?.role_ccadmin || 0}</td>
                              <td>{parentLicence?.available_licence?.role_ccagent || 0}</td>
                              <td>{parentLicence?.available_licence?.live_agent || 0}</td>
                              <td>{parentLicence?.available_licence?.channel || 0}</td>
                              {/* {loginUserRole!==USER_ROLES.COMPANY_ADMIN &&
                                      <td>{parentLicence?.available_licence?.reseller || 0}</td> } */}
                              {!isOwnCompany &&
                                <td>{parentLicence?.available_licence?.company || 0}</td>}
                            </tr>
                          </tbody>
                        </Table>
                      </div>}
                    {/* // */}

                    <Button
                      onClick={submitForm}
                      type="button"
                      variant="btn btn-primary"
                      disabled={buttonDisable || Object.values(errors).some(error => error !== "")}
                    >
                      Create New Company &nbsp;
                      {
                        buttonDisable ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : <></>
                      }
                    </Button>

                  </form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>

      {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}

    </>
  )

}

export default CompanyCreate;
